import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import PhoneNumberInput from './PhoneNumberInput';

const messageOf = (e, fallback) => e.response?.data?.message || (typeof e.response?.data === 'string' ? e.response.data : null) || fallback;

/**
 * Org Admin > Online Store > Grievance officer: the person a buyer can complain to. India's e-commerce rules expect one to be named; the store shows them in its footer and
 * on its Shipping and returns page. Leave all three empty for none.
 */
export default function GrievanceSettings({ storeSaved, onSaved }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const d = (await axios.get('/api/store/grievance')).data;
      setForm({ name: d.name || '', email: d.email || '', phone: d.phone || '' });
      setLoaded(true);
    } catch (e) {
      setLoaded(false);
    }
  }, []);
  useEffect(() => { load(); }, [load, storeSaved]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put('/api/store/grievance', form);
      toast.success('Saved.');
      if (onSaved) onSaved();
    } catch (err) {
      toast.error(messageOf(err, 'Could not save the grievance officer.'));
    } finally {
      setSaving(false);
    }
  };

  if (!loaded || !storeSaved) return null;
  return (
    <Card className="mt-3" data-testid="grievance-settings">
      <Card.Body>
        <Card.Title as="h6">Grievance officer</Card.Title>
        <p className="small text-muted">Who a buyer can complain to. Shown in your store&apos;s footer and on its Shipping and returns page. India&apos;s e-commerce rules expect one to be named: check the wording with your accountant.</p>
        <Form onSubmit={save}>
          <Row className="g-2">
            <Col md={4}><Form.Label className="small mb-0">Name</Form.Label><Form.Control size="sm" value={form.name} maxLength={100} onChange={set('name')} /></Col>
            <Col md={4}><Form.Label className="small mb-0">Email</Form.Label><Form.Control size="sm" type="email" value={form.email} maxLength={150} onChange={set('email')} /></Col>
            <Col md={4}><Form.Label className="small mb-0">Phone</Form.Label><PhoneNumberInput name="phone" value={form.phone} onChange={set('phone')} /></Col>
          </Row>
          <div className="mt-3"><Button type="submit" size="sm" disabled={saving}>Save grievance officer</Button></div>
        </Form>
      </Card.Body>
    </Card>
  );
}
